const currentMonth = new Date().getMonth() + 1
export const shortcut_list = [
    {
        "id": 1,
        "name": "Formulations",
        "description": "Manage all formulation in system ",
        "color": "#8F43EE",
        "url": "/pages/formulations",
        "icon": "YoutubeIcon",
        "permissions" : ['view-formulations','view-partial-formulation-details'],
    },
    {
        "id": 2,
        "name": "Staff Users",
        "description": "Manage all staff users in system",
        "color": "success",
        "url": "/pages/manage-nimble/users",
        "icon": "UsersIcon",
        "permissions" : ['view-staff'],
    },
    {
        "id": 3,
        "name": "Project Briefs",
        "description": "Manage all PBs in system",
        "color": "#F0EB8D",
        "url": "/pages/project-brief",
        "icon": "BarChartIcon",
        "permissions" : ['view-project-brief'],
    },
    {
        "id": 4,
        "name": "RM Orders",
        "description": "Manage all raw material orders",
        "color": "#BE6DB7",
        "url": "/pages/raw-materials?step=1",
        "icon": "BoxIcon",
        "permissions" : ['view-raw-material-orders'],
    },
    {
        "id": 5,
        "name": "Sales Orders",
        "description": "Manage all sales orders",
        "color": "#16FF00",
        "url": "/pages/product-orders",
        "icon": "BoxIcon",
        "permissions" : ['view-order'],
        "stats": [{
                "name": "Today",
                "endpoint": "/admin/report/sales-order-total?interval=daily",
                "dataType": "currency"
            },
            {
                "name": "Monthly",
                "endpoint": `/admin/report/sales-order-total?interval=monthly&month=${currentMonth}`,
                "dataType": "currency"
            }]
    },
    {
        "id": 6,
        "name": "Sample Orders",
        "description": "Manage all sample orders",
        "color": "#16FF00",
        "url": "/pages/sample-orders",
        "icon": "BoxIcon",
        "permissions" : ['view-sample-order'],
    },
    {
        "id": 7,
        "name": "Raw Materials",
        "description": "Manage all raw materials",
        "color": "#16FF00",
        "url": "/pages/raw-materials",
        "icon": "BoxIcon",
        "permissions" : ['view-supplier-raw-materials'],
    },
    {
        "id": 8,
        "name": "Sundry Items",
        "description": "Manage all sundry items",
        "color": "#16FF00",
        "url": "/pages/sundry-items",
        "icon": "BoxIcon",
        "permissions" : [],
    },
    {
        "id": 9,
        "name": "Sundry Orders",
        "description": "Manage all sundry orders",
        "color": "#16FF00",
        "url": "/pages/sundry-items?step=1",
        "icon": "BoxIcon",
        "permissions" : ['view-sundry-orders'],
    },
    {
        "id": 10,
        "name": "Other Services",
        "description": "Manage all other services",
        "color": "#16FF00",
        "url": "/pages/other-supplier-service",
        "icon": "BoxIcon",
        "permissions" : ['view-other-suppliers'],
    },
    {
        "id": 11,
        "name": "Other Orders",
        "description": "Manage all other service orders",
        "color": "#16FF00",
        "url": "/pages/other-supplier-service?step=2",
        "icon": "BoxIcon",
        "permissions" : ['view-other-orders'],
    },
    {
        "id": 12,
        "name": "Stock Checks",
        "description": "Manage all stocks",
        "color": "#16FF00",
        "url": "/pages/stock-check",
        "icon": "BoxIcon",
        "permissions" : ['view-raw-material-stock-inventory', 'view-product-stock-inventory', 'view-sundry-item-stock-inventory'],
    },
    {
        "id": 13,
        "name": "Traceability Audit",
        "description": "Access traceability audit reports",
        "color": "#16FF00",
        "url": "/pages/traceability-audit",
        "icon": "BoxIcon",
        "permissions" : [],
    },
    {
        "id": 14,
        "name": "Mass Balance",
        "description": "Access mass balance reports",
        "color": "#16FF00",
        "url": "/pages/mass-balance-audit",
        "icon": "BoxIcon",
        "permissions" : [],
    },
    {
        "id": 15,
        "name": "Aggregated Activity",
        "description": "Activities of opportunities and contacts",
        "color": "#16FF00",
        "url": "/pages/crm/aggregated-activity",
        "icon": "StarIcon",
        "permissions" : ['executive-admin'],
    },
    {
        "id": 16,
        "name": "CRM Summary",
        "description": "CRM Summary",
        "color": "#16FF00",
        "url": "/pages/crm/aggregated-activity",
        "icon": "StarIcon",
        "permissions" : ['end-user', 'executive-admin'],
    },
    {
        "id": 17,
        "name": "Work Orders",
        "description": "Access work orders",
        "color": "#16FF00",
        "url": "/pages/manufacturing/work-orders",
        "icon": "CpuIcon",
        "permissions" : ['view-work-orders'],
         "stats": [{
            "name": "Today",
            "endpoint": "/admin/report/work-order-total?interval=daily",
            "dataType": ""
        },
        {
            "name": "Monthly",
           "endpoint": "/admin/report/work-order-total?interval=monthly",
            "dataType": ""
        }]
    },
    {
        "id": 18,
        "name": "Manage Customers",
        "description": "Access customers",
        "color": "#16FF00",
        "url": "/pages/manage-nimble/customers",
        "icon": "UsersIcon",
        "permissions" : ['view-customer'],
    },
     {
        "id": 19,
        "name": "Manage RM Suppliers",
        "description": "Access rm suppliers",
        "color": "#16FF00",
        "url": "/pages/manage-nimble/suppliers",
        "icon": "UsersIcon",
        "permissions" : ['view-supplier'],
    },
    {
        "id": 20,
        "name": "Predicted Use Report",
        "description": "Access RM Predicted Use Report",
        "color": "#16FF00",
        "url": "/pages/raw-materials?step=2",
        "icon": "StarIcon",
        "permissions" : ['view-raw-material-use-report'],
    },
    {
        "id": 21,
        "name": "Purchase Orders",
        "description": "Access purchase orders",
        "color": "#16FF00",
        "url": "/pages/po-invoices",
        "icon": "BoxIcon",
        "permissions" : ['view-order'],
        "stats": [{
            "name": "Today",
            "endpoint": "/admin/report/purchase-order-invoice-total?interval=daily",
            "dataType": "currency"
        },
        {
            "name": "Monthly",
            "endpoint": "/admin/report/purchase-order-invoice-total?interval=monthly",
            "dataType": "currency"
        }]
    },
    {
        "id": 22,
        "name": "OTIF",
        "description": "Regional on-time in-full performance",
        "color": "#00CFE8",
        "url": "/pages/otif-report",
        "icon": "TargetIcon",
        "permissions": ['view-otif-target-setting']
    },
    {
        "id": 23,
        "name": "Weekly Schedule",
        "description": "Weekly task schedule overview (Mon - Fri)",
        "color": "#7367F0",
        "url": "/pages/my-schedule",
        "icon": "CalendarIcon",
        "permissions": []
    }
]